// src/components/AppHeader.jsx
import React from 'react';
import {UserCircle2} from 'lucide-react';

export default function AppHeader() {
    return (
        <div className="app-header fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-40 shadow-sm">
            <div className="flex items-center justify-between h-16 px-6">
                {/* Левая часть — иконка + название */}
                <div className="flex items-center gap-3">
                    <UserCircle2 size={36} className="text-blue-600" strokeWidth={2}/>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 leading-none">HOTEL MANAGER</h1>
                        <p className="text-xs text-gray-500 -mt-1">Управление мини-отелем</p>
                    </div>
                </div>

                {/* Правая часть — можно потом аватарку или уведомления */}
                <div className="w-10 h-10"/>
            </div>
        </div>
    );
}
